// extracted by mini-css-extract-plugin
export var layoutContainer = "_6w-0";
export var layoutContainerNoRounding = "_6w-6";
export var layoutContainerOpen = "_6w-5";
export var layoutContainerResizing = "_6w-1";
export var mainContent = "_6w-2";
export var resizeDivider = "_6w-3";
export var slidePanel = "_6w-4";